// extracted by mini-css-extract-plugin
export default {"wrap":"RedeemLoader_wrap__OgWDT","spinner":"RedeemLoader_spinner__sPS-I","spin":"RedeemLoader_spin__LziQL","message":"RedeemLoader_message__qGF7Q"};